import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {onyx} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  card: {
    borderRadius: 3,
    padding: 18,
  },
  border: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: alto,
  },
  shadow: {
    elevation: 10,
    shadowColor: onyx,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.25,
    shadowRadius: 10,
  },
  fullWidth: {
    marginRight: indent,
    marginBottom: indent,
    width: '100%' as const,
    maxWidth: '100%' as const,
  },
});
